import { Component, OnInit } from "@angular/core";
import { MediaObserver } from "@angular/flex-layout";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { TranslateService } from "@ngx-translate/core";
import { interval, of } from "rxjs";
import { filter, startWith, switchMap, tap } from "rxjs/operators";
import { PriceService } from "src/app/dashboard/price/price.service";
import { DialogService } from "src/service/dialog.service";
import { AuthService } from "./auth/auth.service";
import { iconList } from "./data/icon-list";
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  showingRedirectAppStoreMediaAliases = ["lt-md", "lt-sm"];
  showRedirectAppStoreUrl;
  closeRedirect;
  languages = ["de", "en", "nl", "fr", "tr"];
  constructor(
    public translate: TranslateService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private priceService: PriceService,
    private authService: AuthService,
    private dialogService: DialogService,
    private router: Router,
    private mediaObserver: MediaObserver
  ) {
    this.loadIcons();
    this.syncPrices();
  }
  ngOnInit(): void {
    this.translate.addLangs(this.languages);
    this.translate.setDefaultLang("de");
    const browserLang = this.translate.getBrowserLang();
    this.translate.use(
      this.languages.includes(browserLang) ? browserLang : "en"
    );
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        if (e.url.includes("DY1jFI765pz92Tr7OZphOvkDEldyygZO") ||
          e.url.includes("247eTdOJWxFtMRNunNJgx1nrKxd6HHsS")) {
          this.closeRedirect = true;
        }
      }
    });
    this.showRedirectAppStoreUrl = this.mediaObserver.asObservable().pipe(
      switchMap((mediaChange) =>
        of(
          this.showingRedirectAppStoreMediaAliases.includes(
            mediaChange[1].mqAlias
          )
        )
      ),
      // tap((redirect) => {
      //   if (redirect) {
      //   window.location.href = "http://localhost:4200";
      //   }
      // })
    );
  }

  SYNC_PRICE_TIME_INTERAL_MILLISECOND = 60 * 1000;

  loadIcons() {
    iconList.forEach((icon) =>
      this.matIconRegistry.addSvgIcon(
        icon.name,
        this.domSanitizer.bypassSecurityTrustResourceUrl(icon.url)
      )
    );
  }

  syncPrices() {
    interval(this.SYNC_PRICE_TIME_INTERAL_MILLISECOND)
      .pipe(
        startWith(0),
        switchMap(() => this.authService.syncPublicJwt()),
        switchMap(() => this.priceService.fetchPriceList())
      )
      .subscribe(
        () => {},
        (error) => {
             // this.dialogService.showErrorDialog(error.message);
        }
      );
  }
}
